<template>
  <div class="company-info-container">
    <!-- 蓝色到绿色的渐变分隔线 -->
    <div class="gradient-divider"></div>
    
    <div class="company-content">
      <!-- 左侧公司信息 -->
      <div class="left-info">
        <div class="company-name">杭州视向科技有限公司</div>
        <div class="company-details">
          <div class="detail-item">
            <span class="detail-label">地址：</span>
            <span class="detail-text">浙江省杭州市余杭区EFC欧美金融城T2-2804</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">电话：</span>
            <span class="detail-text">15925605780</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">官网：</span>
            <span class="detail-text">www.hubintell.com</span>
          </div>
        </div>
      </div>
      
      <!-- 右侧联系表单 -->
      <div class="right-contact">
        <div class="contact-title">联系我们</div>
        <div class="contact-desc">若您有什么疑问，可以留下您的联系方式</div>
        
        <div class="contact-form">
          <div class="input-group">
            <input 
              v-model="phone" 
              type="text" 
              placeholder="请输入您的电话"
              class="form-input"
            >
          </div>
          <div class="input-group">
            <input 
              v-model="email" 
              type="text" 
              placeholder="请输入您的邮箱"
              class="form-input"
            >
          </div>
          <button class="submit-btn" @click="submitContact">
            提交
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyInfo',
  data() {
    return {
      phone: '',
      email: ''
    }
  },
  methods: {
    submitContact() {
      if (!this.phone && !this.email) {
        alert('请至少填写电话或邮箱');
        return;
      }
      
      // 这里可以添加提交逻辑，比如调用API
      console.log('提交联系方式:', {
        phone: this.phone,
        email: this.email
      });
      
      // 提交后清空表单
      this.phone = '';
      this.email = '';
      
      alert('感谢您的联系，我们会尽快与您沟通！');
    }
  }
}
</script>

<style scoped>
.company-info-container {
  background-color: #1a1a1a;
  color: #ffffff;
  padding: 60px 40px;
  width: 100%;
  margin-top: 50px;
  position: relative;
}

/* 蓝色到绿色的渐变分隔线 */
.gradient-divider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 8px;
  background: linear-gradient(90deg, 
    #16B0EC 0%, 
    #3CBCD8 25%, 
    #62C9C4 50%, 
    #88D5B0 75%, 
    #96DF6D 100%);
  box-shadow: 0 2px 10px rgba(22, 176, 236, 0.3);
}

.company-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 80px;
}

/* 左侧信息样式 */
.left-info {
  flex: 1;
}

.company-name {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 30px;
  color: #ffffff;
  font-family: "黑体", "SimHei", sans-serif;
}

.company-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  line-height: 1.6;
}

.detail-label {
  color: #cccccc;
  min-width: 50px;
  font-weight: 500;
}

.detail-text {
  color: #ffffff;
  flex: 1;
}

/* 右侧联系表单样式 */
.right-contact {
  flex: 1;
  max-width: 400px;
}

.contact-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #ffffff;
}

.contact-desc {
  font-size: 16px;
  color: #cccccc;
  margin-bottom: 30px;
  line-height: 1.5;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-group {
  width: 100%;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  background-color: #2d2d2d;
  border: 1px solid #444444;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: #96DF6D;
  background-color: #333333;
}

.form-input::placeholder {
  color: #888888;
}

.submit-btn {
  background: linear-gradient(135deg, #16B0EC 0%, #96DF6D 100%);
  color: white;
  border: none;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(22, 176, 236, 0.4);
}

.submit-btn:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .company-content {
    gap: 50px;
  }
}

@media (max-width: 768px) {
  .company-info-container {
    padding: 40px 20px;
  }
  
  .company-content {
    flex-direction: column;
    gap: 40px;
  }
  
  .right-contact {
    max-width: 100%;
  }
  
  .company-name {
    font-size: 24px;
  }
  
  .contact-title {
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  .company-info-container {
    padding: 30px 15px;
  }
  
  .company-name {
    font-size: 22px;
  }
  
  .contact-title {
    font-size: 20px;
  }
  
  .detail-item {
    font-size: 14px;
    flex-direction: column;
    gap: 4px;
  }
  
  .detail-label {
    min-width: auto;
  }
  
  .form-input {
    padding: 12px 14px;
    font-size: 14px;
  }
  
  .submit-btn {
    padding: 12px 28px;
    font-size: 15px;
  }
}
</style>